// Generated file : do not modify
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Elements de discussion
export default class ChatItem  {
  // Identifiant unique
  public id: number;
  // Identifiant du chat
  public chatId: number;
  // Identifiant du contact
  public contactId: number;
  // Attribut de substitution si contactId n'existe plus'
  public contactLabel: string;
  // Date de saisie
  public date: Date;
  // Item lu par le destinataire
  public itemRead: boolean;
  // Texte multilignes saisi
  public label: string;
  // 
  public isSystem: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.chatId = 0;
    this.contactId = 0;
    this.contactLabel = '';
    this.date = new Date(1901,1,1,0,0,0,0);
    this.itemRead = false;
    this.label = '';
    this.isSystem = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: ChatItem): ChatItem {
    const newChatItem: ChatItem = new ChatItem();
    newChatItem.id = obj.id;
    newChatItem.chatId = obj.chatId;
    newChatItem.contactId = obj.contactId;
    newChatItem.contactLabel = obj.contactLabel;
    newChatItem.date = new Date(obj.date);
    newChatItem.itemRead = obj.itemRead;
    newChatItem.label = obj.label;
    newChatItem.isSystem = obj.isSystem;
    newChatItem.canUpdate = obj.canUpdate;
    newChatItem.canDelete = obj.canDelete;
    newChatItem.display = obj.display;
    newChatItem.notifDefType = obj.notifDefType;
    return newChatItem;
  }

  public toJsonChatItem (): string {
    const json = {
      chatId: this.chatId,
      contactId: this.contactId,
      contactLabel: this.contactLabel,
      date: this.date ? new Date (this.date).toString() : this.date,
      itemRead: this.itemRead,
      label: this.label,
      isSystem: this.isSystem,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromChatItem (obj: ChatItem): void {
    this.id = obj.id;
    this.chatId = obj.chatId;
    this.contactId = obj.contactId;
    this.contactLabel = obj.contactLabel;
    this.date = new Date(obj.date);
    this.itemRead = obj.itemRead;
    this.label = obj.label;
    this.isSystem = obj.isSystem;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareChatItem (value: ChatItem): boolean {
    return (this.toJsonChatItem() == value.toJsonChatItem());
  }

  public cloneChatItem (): ChatItem {
    return ChatItem.fromJson(this);
  }

  public static getDate(chatItems: ChatItem[]) {
    chatItems.forEach((item) => {
      item.date = item.date ? new Date(item.date) : item.date;
    })
  }
}
